import routes from './routes';

export * from './Pages/index';
export * from './api/index';
export * from './utils/index';
export default routes;
